import React, { useMemo } from 'react';
import { FeatureTogglesProvider } from '../../context/featureToggles';

interface Props {
  featureToggles: string[],
  children: React.ReactNode
}

export function FeatureTogglesWrapper(props: Props) {
  const { children, featureToggles } = props;
  const value = useMemo(() => {
    return {
      hideEnrollmentPage: featureToggles.includes('hide-enrolment-page'),
      hideUserManagement: featureToggles.includes('hide-user-management'),
      showAccessPointsPage: featureToggles.includes('show-access-points-page'),
      showDeviceFinderSettings: featureToggles.includes('show-device-finder-settings'),
      showDeviceWifiTab: featureToggles.includes('show-device-wifi-tab'),
      showAnomalyDetectionBeta: featureToggles.includes('anomaly-detection-beta')
    };
  }, [featureToggles]);
  return (
    <FeatureTogglesProvider value={value}>
      {children}
    </FeatureTogglesProvider>
  );
}
